import React from 'react'
import { HelperModalWithTimeout } from '@/components/composed/HelperModalWithTimeout'
import { ALREADY_SHOWN_SESSION_STORAGE_KEY } from './constants'
import { messages } from './messages'
import type { TFinancingProductHelperProps } from './types'

export const FinancingProductHelper = ({ requestMapper }: TFinancingProductHelperProps) => {
  return (
    <HelperModalWithTimeout
      alreadyShownSessionStorageKey={ALREADY_SHOWN_SESSION_STORAGE_KEY}
      title={messages.title}
      requestMapper={requestMapper}
    />
  )
}
